<template>
  <div class="content" style="position: relative;
  width: 100%;
  height: auto;
  font-size: 12px;">
    <!-- <img class="header" style="
    width: 100%;
    height: auto;
    display: block;" src="../../assets/background-0518-1.jpg"> -->
    <div class="body" style="position: relative;
  width: 100%;
  min-height: 100%;
  height: auto;
  overflow: hidden;">
      <img class="background" style="
  width: 100%;
  height: auto;
  margin-bottom: -3px;" src="../../assets/background-1121.jpg">
  <div style="
    position: absolute;
    bottom: 3.2%;
    left: 16%;
    color: transparent;
    background: -webkit-linear-gradient(#fa5702, #d800ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    font-size: 30px;
  ">
    {{dayTotal}}
  </div>
  <div style="
    position: absolute;
    bottom: 3.2%;
    left: 63%;
    color: transparent;
    background: -webkit-linear-gradient(#fa5702, #d800ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    font-size: 30px;
  ">
    {{monthTotal}}
  </div>
      <div class="con1"
        v-if="data.length > 0"
        style="
    position: absolute;
    top: 35%;
    left: 6%;
    height: 42.2%;
    width: 40.5%;">
        <div
          class="list"
          v-for="(item, i) in data" :key="item.id"
          :style="{
            top: i * topPosition + '%',
            zIndex: i,
            height: topPosition + '%'
          }"
          style="
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;"
          >
          <!-- <div class="item-inner paiming" style="
    display: flex;
    align-items: center;
    height: 100%;
    height: calc( 100% - 10px);
    color: #5ca1d8;
    text-align: center;"><div style="
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #fff;
      line-height: 20px;
      font-weight: bold;">{{item.index}}</div></div> -->
          <div class="item-inner logo"style="
  display: flex;
  align-items: center;
  height: 70%;
  margin: 0 10px;
  width: auto;
  aspect-ratio: 1/1;
  position: relative;">
            <img
            v-if="i === 0"
            style="
            position: absolute;
            top: -47%;
            left: -16%;
            height: 80%;
            width: auto;
            " class="huangguan" src="../../assets/huangguan.png">
            <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`" style="
    width: 100%;
    height: auto;
    border: 1px solid #fff;
    border-radius: 50%;">
          </div>
          <div
            :class="`item`"
            style="
  position: relative;
  color: #fff;
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: row;"
          >
            <div
              class="item-inner total"
              style="
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 12px;
  width: 100%;
  text-align: right;
  justify-content: space-between;
  line-height: 18px;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #fff;
  border-radius: 4px;
  background: #bf61ff;
  padding: 0 5px;"
            >
            <!-- 
  text-shadow: rgb(255 0 255) -1px -1px 3px, rgb(255 0 255) 1px 1px 3px;
  box-shadow: rgba(255, 93, 255, 1) -3px -3px 5px, rgba(0, 0, 0, 0.3) 6px 6px 3px; -->
              <div class="item-inner nickname"
                        style="
              display: flex;
              align-items: center;
              height: 100%;
              font-size: 12px;
              font-weight: bold;
              font-style: italic;
              justify-content: space-between;">
                <span>{{item.nickname }}</span>
              </div>
              <div class="total-inner"
                style="
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  border-radius: 4px 0 0 4px;
              ">
                <span>￥{{ item.total.toFixed(0) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con2"
        v-if="data2.length > 0"
        style="
    position: absolute;
    top: 35%;
    left: 52.5%;
    height: 42.2%;
    width: 40.5%;">
        <div
          class="list"
          v-for="(item, i) in data2" :key="item.id"
          :style="{
            top: i * topPosition + '%',
            zIndex: i,
            height: topPosition + '%'
          }"
          style="
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;"
          >
          <!-- <div class="item-inner paiming" style="
    display: flex;
    align-items: center;
    height: 100%;
    height: calc( 100% - 10px);
    color: #5ca1d8;
    text-align: center;"><div style="
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #fff;
      line-height: 20px;
      font-weight: bold;">{{item.index}}</div></div> -->
          <div class="item-inner logo"style="
  display: flex;
  align-items: center;
  height: 70%;
  margin: 0 10px;
  width: auto;
  aspect-ratio: 1/1;
  position: relative;">
            <img
            v-if="i === 0"
            style="
            position: absolute;
            top: -47%;
            left: -16%;
            height: 80%;
            width: auto;
            " class="huangguan" src="../../assets/huangguan.png">
            <img :src="item.img" class="touxiang" :onerror="`this.onerror=null;this.src='${touxiang}';`" style="
    width: 100%;
    height: auto;
    border: 1px solid #fff;
    border-radius: 50%;">
          </div>
          <div
            :class="`item`"
            style="
  position: relative;
  color: #fff;
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: row;"
          >
            <div
              class="item-inner total"
              style="
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 12px;
  width: 100%;
  text-align: right;
  justify-content: space-between;
  line-height: 18px;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #fff;
  border-radius: 4px;
  background: #bf61ff;
  padding: 0 5px;"
            >
            <!-- 
  text-shadow: rgb(255 0 255) -1px -1px 3px, rgb(255 0 255) 1px 1px 3px;
  box-shadow: rgba(255, 93, 255, 1) -3px -3px 5px, rgba(0, 0, 0, 0.3) 6px 6px 3px; -->
              <div class="item-inner nickname"
                        style="
              display: flex;
              align-items: center;
              height: 100%;
              font-size: 12px;
              font-weight: bold;
              font-style: italic;
              justify-content: space-between;">
                <span>{{item.nickname }}</span>
              </div>
              <div class="total-inner"
                style="
                  height: 100%;
                  display: flex;
                  align-items: center;
                  position: relative;
                  border-radius: 4px 0 0 4px;
              ">
                <span>￥{{ item.total.toFixed(0) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import userList from '../data-1111'
import axios from '../axios-instance'
import moment from 'moment'

const limit = 7.3
export default {
  name: 'page1121',
  components: { },
  watch: {
  },
  data () {
    return {
      data: [
        // {
        //   id: 1,
        //   nickname: '张三',
        //   account: 'zhangsan',
        //   total: 0,
        //   color: '#ff40f8',
        //   img: require('../../assets/logo.png')
        // }
      ],
      data2: [],
      data3: [],
      maxNum: 10000,
      maxNum2: 10000,
      maxNum3: 10000,
      currentDate: moment().format('MM月DD日'),
      topPosition: limit,
      interval: undefined,
      heigth: limit,
      limit,
      animating: false,
      animating2: false,
      animating3: false,
      pendingData: [],
      subscription: null,
      stompClient: null,
      init: false,
      itemWidth: 50,
      userList: [],
      startTime: null,
      endTime: null,
      imgList: {},
      touxiang: require('../../assets/touxiang.png'),
      dayTotal: 0,
      monthTotal: 0
    }
  },
  created () {
    // this.startTime = this.$route.query.startTime
    // this.endTime = this.$route.query.endTime
    // this.userList = userList.map((item) => {
    //   if (item.nickname.indexOf('716') === -1) {
    //     item.nickname += '·716'
    //   }
    //   return item
    // })
  },
  mounted () {
    this.interval = setInterval(() => {
      this.getAllData()
      this.getAllData2()
    }, 20000)
    // this.getAllUserInfo()
    this.getAllData(true)
    this.getAllData2(true)
    // this.getTestData()
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    getAllUserInfo () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/getAll`,
        method: 'get',
        headers: {
          'tenant-id': 1
        }
      })
        .then((res) => {
          // console.log('所有主播数据：', res.data)
          if (res.status === 200 && res.data && res.data.data && res.data.data.length) {
            this.userList = res.data.data.map((item) => {
              item.nickname += '·716'
              return item
            })
          }
        })
    },
    getWidth (total, i) {
      let a = (total || 100) / this.maxNum * 70
      if (a > 20 && a < 30) {
        a = 30 - i
      }
      if (a < 20) {
        a = 20 - i / 2
      }
      return `${a}%`
    },
    getTestData () {
      const data = {
        4: 668989,
        3: 897979,
        2: 798988,
        7: 797897,
        1: 898989,
        10: 667767,
        39: 676878,
        15: 675655,
        18: 45546,
        14: 567575,
        32: 78787,
        44: 97755
      }
      this.loaded(data, true)
    },
    getAllData (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime1121')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 9000) {
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData1121') || '{}'), isFirst)
        return false
      }
      this.getData().then((res) => {
        console.log('日志数据：', res)
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime1121', moment().valueOf())
          window.localStorage.setItem('cacheData1121', JSON.stringify(res.data.data))
          this.loaded(res.data.data, isFirst)
        } else {
          this.loaded(JSON.parse(window.localStorage.getItem('cacheData1121') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded(JSON.parse(window.localStorage.getItem('cacheData1121') || '{}'), isFirst)
      })
    },
    loaded (data, isFirst) {
      let total = 0
      const res = cloneDeep(userList).filter((item) => data[item.id] !== undefined).map((item, i) => {
        item.total = data[item.id] || 0
        total += item.total
        // item.color = !item.type ? '#bf61ff' : '#ff45fe'
        return item
      })
      this.dayTotal = total
      res.sort((a, b) => b.total - a.total)
      
      this.topPosition = this.limit
      
      // console.log(res)
      if (isFirst) {
        this.data = res.map((item, i) => ({...item, total: 0}))
      }
      this.dealData(this.data, res, isFirst)
    },
    getData () {
      return axios({
        // url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/gmvExclusive`,
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/gmvToday`,
        method: 'get',
        headers: {
          'Content-Type': 'form-data/x-www-form-urlencoded'
        }
      })
    },
    dealData (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          // item.top = data[index].top
          item.newNumber = item.total
          item.total = data[index].total
          // item.color = data[index].color
        })
      }
      if (newData && newData.length) {
        newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          // item.newTop = index * this.topPosition
          // item.once = this.getOnce(item.newTop, item.top)
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data = newData
      this.intervalFn(isFirst)
    },
    intervalFn (isFirst) {
      let i = 0
      this.animating = true
      const interval = setInterval(() => {
        i++
        this.data = this.data.map(item => {
          // if (item.top !== item.newTop) {
          //   item.top = item.top + item.once
          // }
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        // this.maxNum = this.data[0]?.total || this.maxNum
        if (i >= 40) {
          clearInterval(interval)
          this.animating = false
        }
      }, 50)
    },
    getAllData2 (isFirst) {
      const lastRequestTime = window.localStorage.getItem('requestTime1121Month')
      if (lastRequestTime && moment().valueOf() - lastRequestTime < 9000) {
        this.loaded2(JSON.parse(window.localStorage.getItem('cacheData1121Month') || '{}'), isFirst)
        return false
      }
      this.getData2().then((res) => {
        console.log('日志数据-月：', res)
        if (res && res.data.code === 0) {
          window.localStorage.setItem('requestTime1121Month', moment().valueOf())
          window.localStorage.setItem('cacheData1121Month', JSON.stringify(res.data.data))
          this.loaded2(res.data.data, isFirst)
        } else {
          this.loaded2(JSON.parse(window.localStorage.getItem('cacheData1121Month') || '{}'), isFirst)
        }
      }).catch((e) => {
        console.error(e)
        this.loaded2(JSON.parse(window.localStorage.getItem('cacheData1121Month') || '{}'), isFirst)
      })
    },
    loaded2 (data, isFirst) {
      let total = 0
      const res = cloneDeep(userList).filter((item) => data[item.id] !== undefined).map((item, i) => {
        item.total = data[item.id] || 0
        total += item.total
        // item.color = !item.type ? '#bf61ff' : '#ff45fe'
        return item
      })
      this.monthTotal = total
      res.sort((a, b) => b.total - a.total)
      
      this.topPosition = this.limit
      
      // console.log(res)
      if (isFirst) {
        this.data2 = res.map((item, i) => ({...item, total: 0}))
      }
      this.dealData2(this.data2, res, isFirst)
    },
    getData2 () {
      return axios({
        url: `https://yudao-api.yunlvltd.com/app-api/vote/cyber-star/gmvCurrentMonth`,
        method: 'get',
        headers: {
          'Content-Type': 'form-data/x-www-form-urlencoded'
        }
      })
    },
    dealData2 (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          // item.top = data[index].top
          item.newNumber = item.total
          item.total = data[index].total
          // item.color = data[index].color
        })
      }
      if (newData && newData.length) {
        newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          // item.newTop = index * this.topPosition
          // item.once = this.getOnce(item.newTop, item.top)
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data2 = newData
      this.intervalFn2(isFirst)
    },
    intervalFn2 (isFirst) {
      let i = 0
      this.animating2 = true
      const interval = setInterval(() => {
        i++
        this.data2 = this.data2.map(item => {
          // if (item.top !== item.newTop) {
          //   item.top = item.top + item.once
          // }
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        this.maxNum2 = this.data2[0].total || this.maxNum2
        if (i >= 40) {
          clearInterval(interval)
          this.animating2 = false
        }
      }, 50)
    },
    dealData3 (data, newData, isFirst) {
      if (data && data.length) {
        data.sort((a, b) => a.id - b.id)
        newData.sort((a, b) => a.id - b.id)
        newData.forEach((item, index) => {
          // item.top = data[index].top
          item.newNumber = item.total
          item.total = data[index].total
          // item.color = data[index].color
        })
      }
      if (newData && newData.length) {
        newData.sort((a, b) => b.newNumber - a.newNumber)
        newData.forEach((item, index) => {
          // item.newTop = index * this.topPosition
          // item.once = this.getOnce(item.newTop, item.top)
          item.numOnce = this.getOnce(item.newNumber, item.total)
        })
      }
      this.data3 = newData
      this.intervalFn3(isFirst)
    },
    intervalFn3 (isFirst) {
      let i = 0
      this.animating3 = true
      const interval = setInterval(() => {
        i++
        this.data3 = this.data3.map(item => {
          // if (item.top !== item.newTop) {
          //   item.top = item.top + item.once
          // }
          if (item.total !== item.newNumber) {
            item.total = item.total + item.numOnce
          }
          return item
        })
        this.maxNum3 = this.data3[0].total || this.maxNum3
        if (i >= 40) {
          clearInterval(interval)
          this.animating3 = false
        }
      }, 50)
    },
    getOnce (n, o) {
      // 分多少次处理
      if (n !== o) {
        return (n - o) / 40
      }
      return 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/single1121/page1121.vue